<template>
  <div class="container">
    <h1>企业微信侧边栏项目首页</h1>
    <a-button type="primary" @click="goForm">模拟跳转表单页</a-button>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {};
  },
  methods: {
    goForm() {
      this.$router.push(
        `/login/ww7ac6c380a2472a67/1000002?redirect=/schoolUserInfo/1526840652565331969`
      );
    },
  },
  created() {},
};
</script>
